<template>
  <el-dialog
    :visible.sync="isOpen"
    :show-close="true"
    class="egl-dialog-elm channel-dialog memberList"
    :title="$locale('membership.memberList.dialog.title')"
    :close-on-click-modal="false"
    :before-close="closeHanlder"
  >
    <el-form
      :model="formObj"
      ref="detailForm"
      label-position="top"
    >
      <Basic :propForm="formObj" @closeParent="closeHanlder" />
      <div class="border"></div>
      <Information :propForm="formObj" @refreshMemberShip="getMemberShipChangeLog" @refreshRank="getRankLog"/>
      <div class="border"></div>
      <PersonalInformation :propForm="formObj" />
      <div class="border"></div>
      <History :id="formObj.id" :isDialogOpen="isOpen" ref="historyRef" @refreshCoupon="getMemberCouponLog" @refreshCouponUse="getCouponUseLog"
      @refreshPoint="getPointLog" />
    </el-form>
  </el-dialog>
</template>
<script>
import Basic from '@/components/MemberShip/MemberList/Basic.vue'
import Information from '@/components/MemberShip/MemberList/Information.vue'
import PersonalInformation from '@/components/MemberShip/MemberList/PersonalInformation.vue'
import History from '@/components/MemberShip/MemberList/History.vue'

import { getMemberCouponLogService, getCouponUseLogService, getPointLogService, getRankLogService, getMemberShipChangeLogService } from "@/helpers/service/api/membership";
export default {
  data() {
    return {
      formObj: {}
    }
  },
  methods: {
    closeHanlder() {
      this.$emit('update:isOpen', false)
    },
    async getMemberCouponLog() {
      const tableObj = this.$refs['historyRef'].tableObj
      const filter = this.$refs['historyRef'].filter
      await getMemberCouponLogService({
        userId: this.formObj.id,
        page: 0,
        pageSize: 20,
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          tableObj.coupon.tableData = res.data.data
          filter.coupon.count = res.data.count
        } else {
          tableObj.coupon.tableData = []
        }
      })
    },
    async getCouponUseLog() {
      const tableObj = this.$refs['historyRef'].tableObj
      const filter = this.$refs['historyRef'].filter
      await getCouponUseLogService({
        userId: this.formObj.id,
        page: 0,
        pageSize: 20,
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          tableObj.couponUse.tableData = res.data.data
          filter.couponUse.count = res.data.count
        } else {
          tableObj.couponUse.tableData = []
        }
      })
    },
    async getPointLog() {
      const tableObj = this.$refs['historyRef'].tableObj
      const filter = this.$refs['historyRef'].filter
      await getPointLogService({
        userId: this.formObj.id,
        page: 0,
        pageSize: 20,
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          tableObj.point.tableData = res.data.data
          filter.point.count = res.data.count
        } else {
          tableObj.point.tableData = []
        }
      })
    },
    async getRankLog() {
      const tableObj = this.$refs['historyRef'].tableObj
      const filter = this.$refs['historyRef'].filter
      await getRankLogService({
        userId: this.formObj.id,
        page: 0,
        pageSize: 20,
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          tableObj.rank.tableData = res.data.data
          filter.rank.count = res.data.count
        } else {
          tableObj.rank.tableData = []
        }
      })
    },
    async getMemberShipChangeLog() {
      const tableObj = this.$refs['historyRef'].tableObj
      const filter = this.$refs['historyRef'].filter
      await getMemberShipChangeLogService({
        userId: this.formObj.id,
        page: 0,
        pageSize: 20,
      }).then(res => {
        if (res.data && res.data.data.length > 0) {
          tableObj.memberShipChange.tableData = res.data.data
          filter.memberShipChange.count = res.data.count
        } else {
          tableObj.memberShipChange.tableData = []
        }
      })
    },
  },
  components: {
    Basic,
    Information,
    PersonalInformation,
    History
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>